
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-admissions",
      function () {
        return require("private-next-pages/tnpsc-admissions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-admissions"])
      });
    }
  